import blpAuth from './blp-auth';

export async function startLimitedInputAuth() {
	return fetch(`${process.env.REACT_APP_SYNC_HOST}/limited-input/start`, {
		method: 'POST',
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		return null;
	}).catch((error) => {
		console.error(error);
	});
}

export async function checkLimitedInputAuth(sessionId: string, uniqueCode: string) {
	return fetch(`${process.env.REACT_APP_SYNC_HOST}/limited-input/check?sessionId=${sessionId}&uniqueCode=${uniqueCode}`, {
		method: 'GET',
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		return null;
	}).catch((error) => {
		console.error(error);
	});
}

export async function authorizeLimitedInput(
	authCode: string,
	redirectToRoom: string,
): Promise<boolean> {
	return fetch(`${process.env.REACT_APP_PLATFORM_API_HOST}/v4/admin/auth/limited-input/authorize?uniqueCode=${authCode}&redirectToRoom=${encodeURIComponent(redirectToRoom)}`, {
		method: 'POST',
		headers: {
			Authorization: blpAuth.accessToken ? `Bearer ${blpAuth.accessToken}` : undefined,
		},
		credentials: blpAuth.accessToken ? undefined : 'include', // needed for cookie auth
	} as RequestInit)
		.then((res) => !!res.ok)
		.catch((error) => {
			console.error(error);
			return false;
		});
}
